"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecursiveCategories = void 0;
/**
 * This recursively gets categories in a breadcrumb, nestedBreadcrumbs and orderedList format
 * ```
 * - breadcrumb: "Products > Tools > Pliers and pincers"
 * - nestedBreadcrumbs: ["Products", "Products > Tools", "Products > Tools > Pliers and pincers"]
 * - orderedList: ["Products", "Tools", "Pliers and pincers"]
 * ```
 * ```js
 * // usage:
 * const {breadcrumb, nestedBreadcrumbs, orderedList} = getCategoryBreadcrumbs(category)
 *
 * ```
 *
 **/
const getRecursiveCategories = (category) => {
    if (category) {
        const orderedList = [];
        const referencedBreadCrumbs = [];
        const recursiveAddCategory = (parentCategory) => {
            orderedList.unshift(parentCategory.title);
            referencedBreadCrumbs.unshift({
                title: parentCategory.title,
                slug: parentCategory.slug,
            });
            if (parentCategory.parent) {
                recursiveAddCategory(parentCategory.parent);
            }
        };
        recursiveAddCategory(category);
        const nestedBreadcrumbs = orderedList.reduce((acc, _curr, index, arr) => {
            return [...acc, arr.slice(0, index + 1).join(' > ')];
        }, []);
        const breadcrumbs = orderedList.join(' > ');
        return {
            breadcrumbs,
            nestedBreadcrumbs,
            orderedList,
            referencedBreadCrumbs,
        };
    }
    else {
        return {
            breadcrumbs: '',
            nestedBreadcrumbs: [],
            orderedList: [],
            referencedBreadCrumbs: [],
        };
    }
};
exports.getRecursiveCategories = getRecursiveCategories;
//# sourceMappingURL=utils.js.map